

import { Card } from "@/components/Card/Card";
import { PrimaryButton } from "@/components/Buttons/PrimaryButton";
import { SecondaryButton } from "@/components/Buttons/SecondaryButton";
import { Spacing } from "@/components/Spacing/Spacing";
import { useTranslations } from "next-intl";
import { Link } from "react-router-dom";

export const ExpiredOtpPopup: React.FC = () => {
  const t = useTranslations("changePassword");

  return (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black/50 z-50">
      <Card header={t("linkExpiredTitle")} width="w-[95vw] sm:max-w-125" padding="p-6 sm:p-12" outline="outline-quaternary" shadow="shadow-xl">
        <Spacing height="h-12" />
        <p className="body-1-regular">{t("popupMessage")}</p>
        <Spacing height="h-12" />
        <Link to="/auth/reset-password">
          <PrimaryButton size="small" text={t("requestNewLink")} />
        </Link>
        <Spacing height="h-3" />
        <Link to="/auth/login">
          <SecondaryButton size="small" text={t("goHome")} />
        </Link>
      </Card>
    </div>
  );
};
